import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import Feedback from 'components/Practice/RolePlay/PartnerGuide/Feedback';

const RolePlayFeedbackTable = ({
  partnerName,
  comments,
  criteria,
  overallScore,
}) => {
  const FeedbackCell = () => {
    return criteria.map((criterion, index) => {
      if (index === 0) {
        return (
          <tr>
            <td className="RolePlayCriteriaCell">
              <Feedback
                title={criterion.name}
                score={criterion.score}
                disabled
                textVariantBody
              />
            </td>
            <td
              rowSpan={criteria.length + 1}
              className="va-top p-10 RolePlayCriteriaCell ws-pl"
            >
              <Text variant={TEXT_VARIANTS.BODY}>{comments}</Text>
            </td>
          </tr>
        );
      }
      return (
        <tr>
          <td className="RolePlayCriteriaCell">
            <Feedback
              title={criterion.name}
              score={criterion.score}
              disabled
              textVariantBody
            />
          </td>
        </tr>
      );
    });
  };

  return (
    <table className="RolePlayCriteriaTable">
      <caption className="pt-0 pb-0">
        <div className="RolePlayCriteriaTableHeader">
          <Text variant={TEXT_VARIANTS.SUBHEADER}>
            {t('practice.role_play.feedback.feedback_from')}
            <span className="pl-4">{partnerName}</span>
          </Text>
        </div>
      </caption>
      <thead>
        <tr>
          <th className="RolePlayCriteriaColumnHeader">
            <Text variant={TEXT_VARIANTS.BODY_BOLD}>
              {t('practice.role_play.feedback.criteria')}
            </Text>
          </th>
          <th className="RolePlayCriteriaColumnHeader">
            <Text variant={TEXT_VARIANTS.BODY_BOLD}>
              {t('practice.role_play.feedback.comments')}
            </Text>
          </th>
        </tr>
      </thead>
      <tbody>
        {criteria.length === 0 ? (
          <tr>
            <FeedbackCell />
            <td className="RolePlayCriteriaCell">
              {' '}
              <Feedback
                title={t(
                  'practice.role_play.grading_criteria.overall_score_title',
                )}
                score={overallScore}
                disabled
                textVariantBody
                bold
              />
            </td>
            <td className="va-top p-10 RolePlayCriteriaCell ws-pl">
              <Text variant={TEXT_VARIANTS.BODY}>{comments}</Text>
            </td>
          </tr>
        ) : (
          <>
            <FeedbackCell />
            <td className="RolePlayCriteriaCell">
              {' '}
              <Feedback
                title={t(
                  'practice.role_play.grading_criteria.overall_score_title',
                )}
                score={overallScore}
                disabled
                textVariantBody
                bold
              />
            </td>
          </>
        )}
      </tbody>
    </table>
  );
};

export default RolePlayFeedbackTable;
